import { Box, Typography } from '@mui/material';
import useFreeTrialStatus from '../../hooks/subscriptions/useFreeTrialStatus';
import { ROUTES } from '../../constants/global';
import { canUserManageSubscription } from '../../helpers/subscriptions';
import useUser from '../../hooks/global/useUser';
import Banner from '../global/Banner';

export const BANNER_HEIGHT = 45;

function FreeTrialBanner() {
  const { user } = useUser();
  const { daysRemaining, isBannerShown, hideBanner } = useFreeTrialStatus();

  const canManageSubscription = canUserManageSubscription(user);

  const days = Math.max(1, daysRemaining);
  const daysString = `${days} day${days > 1 ? 's' : ''}`;

  return (
    <Banner
      isVisible={isBannerShown}
      hideBanner={hideBanner}
      action={
        canManageSubscription ? { href: ROUTES.subscription } : undefined
      }>
      <Typography variant="h5" color="inherit">
        {daysString} left in your free trial.
      </Typography>
      {/* flex when md >, hidden when smaller */}
      {canManageSubscription && (
        <Box display={{ xs: 'none', sm: 'flex' }} gap={1} alignItems="center">
          <Typography
            variant="body2"
            color="inherit"
            marginLeft={1}
            sx={{
              // eslint-disable-next-line no-restricted-syntax -- typography-exception: banner link must beat the global anchor colour with !important; palette paths cannot carry !important
              color: '#ffffff !important',
            }}>
            Subscribe now
            <Typography
              variant="body2"
              color="inherit"
              display={{
                xs: 'none',
                md: 'inline',
              }}
              component="span"
              // eslint-disable-next-line no-restricted-syntax -- typography-exception: banner link must beat the global anchor colour with !important; palette paths cannot carry !important
              sx={{ color: '#ffffff !important' }}>
              {' '}
              to keep access to your account
            </Typography>
          </Typography>
        </Box>
      )}
    </Banner>
  );
}

export default FreeTrialBanner;
